import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Label from '../label/Label';
import Input from '../input/Input';
import HelpWrapper from '../help/HelpWrapper';
import Popover from '../popover/Popover';
import Error from '../error/Error';
import useAriaProps from '../hooks/useAriaProps';

function InputGroup(_ref) {
  var self = _ref.self,
      label = _ref.label,
      input = _ref.input,
      customInput = _ref.customInput,
      cta = _ref.cta,
      ctaLeft = _ref.ctaLeft,
      size = _ref.size,
      popover = _ref.popover;
  var cssClass = classNames('tds-form__group', self.classNames);
  var ctaWrap = cta ? /*#__PURE__*/React.createElement("span", {
    className: "tds-input-group__btn"
  }, cta) : null;
  var hasPopoverHelp = self.helpText && popover;
  var hasStaticHelp = self.helpText && !popover;

  var _useAriaProps = useAriaProps(self.groupId, self.error),
      errorDescribeId = _useAriaProps.errorDescribeId,
      ariaProps = _useAriaProps.ariaProps;

  var renderedInput = customInput || /*#__PURE__*/React.createElement(Input, _extends({
    size: size,
    inverse: self.inverse,
    id: self.groupId
  }, input, {
    errorState: !!self.error
  }, ariaProps));
  var wrappedInput = hasPopoverHelp ? /*#__PURE__*/React.createElement(Popover, _extends({
    onFocusBehavior: true,
    content: self.helpText,
    theme: self.helpFormat
  }, popover), renderedInput) : renderedInput;
  return /*#__PURE__*/React.createElement("div", {
    className: cssClass
  }, label && /*#__PURE__*/React.createElement(Label, _extends({
    size: size,
    inverse: self.inverse,
    htmlFor: self.groupId
  }, label, {
    disabled: input.disabled
  })), hasStaticHelp && /*#__PURE__*/React.createElement(HelpWrapper, {
    classNames: self.helpClassNames,
    format: self.helpFormat,
    theme: self.helpTheme
  }, self.helpText), /*#__PURE__*/React.createElement("div", {
    className: "tds-input-group"
  }, ctaLeft && ctaWrap, wrappedInput, !ctaLeft && ctaWrap), self.error && /*#__PURE__*/React.createElement(Error, {
    id: errorDescribeId,
    error: self.error
  }));
}

InputGroup.displayName = "InputGroup";
InputGroup.defaultProps = {
  size: 'md',
  customInput: null,
  cta: null,
  ctaLeft: false
};
InputGroup.propTypes = {
  self: PropTypes.shape({
    classNames: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    inverse: PropTypes.bool,
    groupId: PropTypes.string,
    error: PropTypes.string,
    helpText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    helpFormat: PropTypes.string,
    helpClassNames: PropTypes.string,
    helpTheme: PropTypes.string,
    popoverHelp: PropTypes.bool
  }),
  label: PropTypes.shape({
    hide: PropTypes.bool,
    inline: PropTypes.bool,
    emphasis: PropTypes.bool,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
  }),
  input: PropTypes.shape({
    type: PropTypes.string,
    list: PropTypes.string,
    classNames: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    error: PropTypes.node,
    borderBottom: PropTypes.bool,
    disabled: PropTypes.bool,
    icon: PropTypes.node,
    onCleared: PropTypes.func,
    iconRight: PropTypes.bool,
    clearable: PropTypes.bool,
    // eslint-disable-next-line react/forbid-prop-types
    inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
      current: PropTypes.any
    })])
  }),
  size: PropTypes.oneOf(['sm', 'lg', 'md']),
  customInput: PropTypes.node,
  cta: PropTypes.node,
  ctaLeft: PropTypes.bool,
  popover: PropTypes.shape({
    className: PropTypes.string,
    title: PropTypes.string,
    icon: PropTypes.string,
    placement: PropTypes.oneOf(['top', 'bottom', 'left', 'right', 'auto']),
    width: PropTypes.number,
    push: PropTypes.oneOf(['left', 'right']),
    closable: PropTypes.bool,
    tooltipBehavior: PropTypes.bool,
    forceCloseOnClick: PropTypes.bool,
    onToggle: PropTypes.func,
    onClosed: PropTypes.func,
    animated: PropTypes.bool
  })
};
InputGroup.defaultProps = {
  self: {},
  label: {},
  input: {},
  popover: null
};
export default InputGroup;